import { Component, OnInit,OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AngularFirestore } from 'angularfire2/firestore';
import { Subscription } from 'rxjs';
import { Localidades, ILocalidades } from '../../../../models/localidades.model';
import { DataModelComponent } from '../../../../models/data.model.component';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';
import { NavigatorGeolocation } from '../../services/navigator_geolocation';
import { HttpClient } from '@angular/common/http';



@Component({
  selector: 'app-localidades',
  templateUrl: './localidades.component.html',
  styleUrls: ['./localidades.component.scss']
})
export class LocalidadesComponent  extends DataModelComponent<ILocalidades> implements OnInit,OnDestroy {
  dataSource: Array<any> = [];
  dataClass: Localidades;
  dataEvent: Subscription;
  @ViewChild('grid') grid: MatDataGridComponent;
  colunas = [{field:"nome",text:"Nome"},
             {"field":"estado",text:"Estado"},
             {"field":"distancia",text:"Distância"},
             //{field:"ceps",text:"CEPs"}
            ];

  constructor(private db: AngularFirestore,private http: HttpClient) {
    super( {
       nome: new FormControl(),
       estado: new FormControl(),
       ceps: new FormControl(),
       inativo: new FormControl(),
    });
    this.dataClass = new Localidades(db);
  }

  ngOnInit() {
    this.dataEvent = this.dataClass.changedEvent.subscribe(
      d => {
        this.dataSource = d.sort(function(a:any,b:any) {return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0);} );
      });
      this.dataClass.verInativo=false;  
  }

  ngOnDestroy(){
    this.dataEvent.unsubscribe();
  }

  doPostItem(event){
    this.dataClass.post(this.item);
    super.doPostItem(event);
  }

  getFilterAttrib(){
    return 'ver inativos';
  }

  doCheckFilter(x:boolean){
    this.dataClass.verInativo = this.grid.checkFilterValue;
  }

  
  buscarGeolocation(){
    let ng = new NavigatorGeolocation(this.http);
    let x:any = this.item;
    let ender = x.nome+','+x.estado;
    let rsp = ng.getGeoLocationByAddress(ender)
    .subscribe(coord=>{
       this.item.latitude = coord.lat;
       this.item.longitude = coord.lng;
      
       //this.item.location = new GeoPoint(coord.lat,coord.lng);
    });
   }

   googleMapUrl:string='';
   verMapa(){
     if (this.item.latitude && this.item.longitude){
       let ng = new NavigatorGeolocation(this.http);
      this.googleMapUrl = ng.getGoogleMapUrl(this.item.latitude,this.item.longitude);
      window.open(this.googleMapUrl);
     }
   }
    

}
